"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MultiListSearchService = exports.FilterState = void 0;
const tslib_1 = require("tslib");
const core_shared_1 = require("@ikegps/core-shared");
const mobx_1 = require("mobx");
const modal_service_1 = require("../components/modal/modal.service");
const index_1 = require("./index");
const SEARCH_DELAY = 200;
class FilterState {
    setFilter(value) {
        this.filter = value;
    }
    hasFilter() {
        return (this.filter != null && this.filter.trim().length > 0);
    }
    clear() {
        this.filter = null;
    }
}
exports.FilterState = FilterState;
tslib_1.__decorate([
    mobx_1.observable
], FilterState.prototype, "filter", void 0);
tslib_1.__decorate([
    mobx_1.action
], FilterState.prototype, "setFilter", null);
tslib_1.__decorate([
    mobx_1.action
], FilterState.prototype, "clear", null);
class MultiListSearchService {
    constructor(delay = SEARCH_DELAY) {
        this.__priority = 100;
        this.filtering = false;
        this.inputfilterState = new FilterState();
        this.filterState = new FilterState();
        this.searchTask = new core_shared_1.IkeDelayedTask(() => this.search(), delay);
    }
    init() {
        (0, mobx_1.reaction)(_ => this.inputfilterState.filter, _ => this.searchTask.delay());
        (0, mobx_1.reaction)(_ => index_1.Services.Department.current, _ => this.reset());
    }
    reset() {
        this.inputfilterState.clear();
        this.filterState.clear();
    }
    search() {
        if (!this.inputfilterState.hasFilter()) {
            this.filterState.setFilter(this.inputfilterState.filter);
            this.filtering = false;
            return;
        }
        this.filtering = true;
        modal_service_1.ModalService.view();
        this.filtering = false;
    }
}
exports.MultiListSearchService = MultiListSearchService;
tslib_1.__decorate([
    mobx_1.observable
], MultiListSearchService.prototype, "filtering", void 0);
tslib_1.__decorate([
    mobx_1.action
], MultiListSearchService.prototype, "search", null);
//# sourceMappingURL=multi.list.search.service.js.map